export const clientNameFooter = "YOGA É SIMPLES";
export const titleMain = "Que bom que você está aqui!";
export const subtitleMain = "O que você quer fazer hoje?";

export const aspectRatioLogoAbout = '2'; // width/height
export const aspectRatioLogoMain = '1'; // width/height

export const borderRadiusButtons = '20px';

export const nomeFornecedorCompleto = "ANA CAROLINA DUQUE DOS SANTOS";
export const nomeFornecedor = "YOGA É SIMPLES";
export const artigo = "a";
export const artigoCaps = "A";

export const footerSocialData = [
  {
    type: "material-community",
    name: "instagram",
    link: "https://www.instagram.com/ana_aditi/",
    profile: "@ana_aditi"
  },
  {
    type: "material-community",
    name: "youtube",
    link: "https://www.youtube.com/channel/UCrz-LgFZAjM5cu5Zg3eoMmA?app=desktop",
  },

  {
    type: "material-community",
    name: "whatsapp",
    link: "https://wa.me/556199994543",
    number: "(61) 9999-4543"
  },
];

export const drawerClosedLinks = [
  {
    title: "Fale Comigo",
    link: "https://wa.me/556199994543",
  },
];

export const linkAppleStore = null
export const linkPlayStore = null

export const hasOutsideAboutPage = false;
export const drawerOpenedLinks = [];